import React from 'react';

const HeaderItem = ({ children, style }) => {
  const finalStyle = { padding: '0 19px 0 19px', ...style };

  return <div style={finalStyle}>{children}</div>;
};

export default HeaderItem;
